import React, { useEffect, useState } from "react";
import { useAppQuery } from "../../../api/fetchClient";
import { QUERY_KEYS } from "../../../api/queryKeys";
import { GET_CATEGORIES, GET_STORIES, GETSTORY_CETEGORY } from "../../../api/url";
import { useNavigate } from "react-router-dom";
import { arrowBack, arrowForward, ProfileImage } from "../../../assets/image";
import moment from "moment";
import Loader from "../../../components/common/Loader";
import { strings } from "../../../strings/strings";

const Stories = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [activeTab, setActiveTab] = useState("");

  const { data: categoryData, isLoading: isCategoryLoading } = useAppQuery({
    queryKey: [QUERY_KEYS.CATEGORIES],
    url: `${GET_CATEGORIES}?type=story`,
  });

  const { data, isLoading } = useAppQuery({
    queryKey: [QUERY_KEYS.STORY_CATEGORY, page, activeTab],
    url: activeTab ? `${GETSTORY_CETEGORY}?categoryId=${activeTab}` : GET_STORIES,
  });

  const handlestory = (story) => {
    navigate("/admin/story/storiesdetails", { state: { storyId: story._id } });
  };

  const handleUserProfile = (user) => {
    navigate("/admin/user/userDetails", { state: { userId: user._id } });
  };
useEffect(() => {
  if (categoryData?.results?.length > 0 && activeTab === "") {
    setActiveTab(""); // Set to show "All blogs"
  }
}, [categoryData, activeTab]);
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPage(1);
  };

  const stories = Array.isArray(data?.results?.data) ? data.results.data : [];
  const { pagination } = data?.results ?? {};
  const { currentPage = 1, totalPages = 1 } = pagination ?? {};

  if (isLoading || isCategoryLoading) {
    return <Loader />;
  }

  return (
    <div>
      <div className="sm:flex sm:items-center">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-primary">Inspiring Stories</h1>
          <p className="mt-2 text-sm text-gray-700 capitalize">A list of all Stories with category uploded by users.</p>
        </div>
      </div>
      <div className="overflow-x-auto">
        <div className="flex gap-3 mb-6 min-w-max">
          <button
            onClick={() => handleTabChange("")}
            className={`text-sm font-medium py-2 px-4 rounded-md whitespace-nowrap ${
              activeTab === "" ? "bg-primary text-white" : "bg-white text-gray-700"
            }`}
          >
            All
          </button>
          {Array.isArray(categoryData?.results) &&
            categoryData.results.map((cat) => (
              <button
                key={cat?._id}
                onClick={() => handleTabChange(cat._id)}
                className={`text-sm font-medium py-2 px-4 rounded-md whitespace-nowrap ${
                  activeTab === cat._id ? "bg-primary text-white" : "bg-white text-gray-700"
                }`}
              >
                {cat?.tittle}
              </button>
            ))}
        </div>
      </div>
      {stories.length === 0 ? (
        <div className="flex items-center justify-center h-[calc(100vh-200px)]">
          <p className="text-center text-gray-500 text-lg">{strings.noStoryAvailble}</p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {stories.map((story) => (
              <div
                key={story?._id}
                className="bg-white rounded-2xl shadow transition-shadow duration-300 ease-in-out hover:shadow-lg cursor-pointer"
              >
                <div className="flex flex-col sm:flex-row gap-5 p-4 items-center">
                  <img
                    src={story?.storyImage}
                    alt="Story"
                    onClick={() => handlestory(story)}
                    className="w-36 h-36 object-cover rounded-md"
                  />
                  <div className="flex flex-col justify-center flex-1 h-full">
                    <div className="grid items-center gap-3 mb-2 sm:mb-0">
                      <p className="font-semibold text-gray-800 line-clamp-1">{story.tittle}</p>
                      <div onClick={() => handleUserProfile(story.user)} className="flex items-center gap-3 mb-3">
                        <img
                          src={story.user?.profileImage || ProfileImage}
                          alt={story.user?.userName}
                          className="w-8 h-8 rounded-full object-cover"
                        />
                        <h3 className="font-semibold text-gray-800">{story.user?.userName}</h3>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <p className="text-sm text-light">{moment(story?.createdAt).fromNow()}</p>
                      <button
                        onClick={() => handlestory(story)}
                        className="bg-primary text-white text-sm sm:text-base font-semibold py-1 px-3 rounded-lg transition-colors duration-300 hover:bg-blue-600"
                      >
                        View
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {totalPages > 1 && (
            <div className="mt-6 flex justify-center items-center space-x-2">
              <button
                onClick={() => setPage((old) => Math.max(old - 1, 1))}
                disabled={page === 1}
                className={`flex items-center px-2 sm:px-3 py-2 rounded-md border text-sm font-medium ${
                  page === 1
                    ? "bg-gray-200 text-light cursor-not-allowed"
                    : "bg-white text-gray-700 hover:bg-gray-100 border-gray-300"
                }`}
              >
                <img src={arrowBack} alt="" />
              </button>

              {Array.from({ length: totalPages }, (_, index) =>
                index < 2 || index > totalPages - 3 || Math.abs(page - (index + 1)) <= 1 ? (
                  <button
                    key={index}
                    onClick={() => setPage(index + 1)}
                    className={`px-3 sm:px-4 py-2 rounded-md border text-sm font-medium ${
                      currentPage === index + 1
                        ? "bg-primary text-white border-primary"
                        : "bg-white text-gray-700 hover:bg-gray-100 border-gray-300"
                    }`}
                  >
                    {index + 1}
                  </button>
                ) : null
              )}

              <button
                onClick={() => setPage((old) => old + 1)}
                disabled={page === totalPages}
                className={`flex items-center px-2 sm:px-3 py-2 rounded-md border text-sm font-medium ${
                  page === totalPages
                    ? "bg-gray-200 text-light cursor-not-allowed"
                    : "bg-white text-gray-700 hover:bg-gray-100 border-gray-300"
                }`}
              >
                <img src={arrowForward} alt="" />
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Stories;
